import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUniformity = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.877 4.243 37.35 9.41l-6.533 6.533-5.94-2.46ZM38.59 10.65l5.167 12.473h-9.24l-2.46-5.94ZM43.757 24.877 38.59 37.35l-6.533-6.533 2.46-5.94ZM23.123 43.757 10.65 38.59l6.533-6.533 5.94 2.46ZM9.41 37.35 4.243 24.877h9.24l2.46 5.94ZM10.65 9.41l12.473-5.167v9.24l-5.94 2.46ZM24 16.4l5.374 2.226L31.6 24l-2.226 5.374L24 31.6l-5.374-2.226L16.4 24l2.226-5.374Z" })
});
export default SvgUniformity;
